export default __webpack_public_path__ + "static/media/work-together.cb11cac2.svg";